import { Alert } from 'antd';

const CustomAlert = ({ status }: any) => {
  const upperStatus = status ? status
    .replace('/', 'or')
    .trim()
    .replace(/\s/g, '_')
    .toUpperCase() : 'error'

  const customConfig: Record<
    string,
    {
      type: 'success' | 'info' | 'warning' | 'error';
      style?: React.CSSProperties;
      className?: string;
    }
  > = {
    ANULADO: {
      type: 'error',
      style: {
        backgroundColor: '#f0f0f0',
        color: '#000',
        border: '1px solid #d9d9d9',
      },
      className: 'alert-anulado',
    },
    APROBADO: {
      type: 'success',
      style: {
        backgroundColor: 'rgb(231, 198, 255)',
        color: '#000',
        border: '1px solid rgb(168, 93, 255)',
      },
      className: 'alert-aprobado',
    },
    ENVIADO: { type: 'info' },
    FINALIZADO: {
      type: 'success',
      style: {
        backgroundColor: 'rgb(144 241 164 / 18%)',
        color: '#000',
        border: '1px solid rgb(82 244 152)',
      },
      className: 'alert-finalizado',
    },
    NO_RECIBIDO: {
      type: 'error',
      style: {
        backgroundColor: 'rgba(230, 176, 170, 0.5)',
        color: '#000',
        border: '1px solid #e6b0aa',
      },
      className: 'alert-no-recibido',
    },
    ENTREGADO: {
      type: 'success',
       style: {
        backgroundColor: '#fff6cc',
        color: '#000',
        border: '1px solid #ffdd1f',
      },
      className: 'alert-entregado',
    },
    NO_ENTREGADO: {
      type: 'error',
      style: {
        backgroundColor: 'rgba(260, 158, 114, 0.18)',
        color: '#000',
        border: '1px solid #fa8072',
      },
      className: 'alert-no-entregado',
    },
    NUEVO: { type: 'info' },
    POR_APROBAR: {
      type: 'info',
      style: {
        backgroundColor: 'rgb(144 163 241 / 21%)',
        color: '#000',
        border: '1px solid rgb(108 111 228)',
      },
      className: 'alert-por-aprobar',
    },
    POR_RECIBIR: {
      type: 'info',
      style: {
        backgroundColor: '#fff6cc',
        color: '#000',
        border: '1px solid #ffdd1f',
      },
      className: 'alert-por-recibir',
    },
    POR_REGISTRAR: {
      type: 'info',
      style: {
        backgroundColor: 'rgb(0 206 209 / 23%)',
        color: '#000',
        border: '1px solid rgb(0, 190, 190)',
      },
      className: 'alert-por-registrar',
    },
    RECHAZADO: {
      type: 'error',
      style: {
        backgroundColor: 'rgb(255 77 79 / 21%)',
        color: '#000',
        border: '1px solid rgb(246 78 74)',
      },
      className: 'alert-rechazado',
    },
    ASIGNADO: {
      type: 'info',
      style: {
        backgroundColor: 'rgba(237, 187, 153, 0.25)',
        color: '#000',
        border: '1px solid #EDBB99',
      },
      className: 'alert-asignado',
    },
    DEVUELTO: { type: 'error' },
    RECHAZADO_OR_ANULADO: {
      type: 'error',
      style: {
        backgroundColor: 'rgb(255 77 79 / 21%)',
        color: '#000',
        border: '1px solid rgb(246 78 74)',
      },
      className: 'alert-rechazado',
    },
    DEVUELTO_A_TÉCNICO: {
      type: 'info',
      style: {
        backgroundColor: 'rgba(247, 220, 111, 0.2)',
        color: '#000',
        border: '1px solid #f7dc6f',
      },
      className: 'alert-devuelto-tecnico',
    },
    NO_REALIZADO: {
      type: 'error',
      style: {
        backgroundColor: 'rgba(250, 128, 114, 0.2)',
        border: '1px solid #FA8072',
      },
      className: 'alert-no-realizado',
    },
    RECIBIDO: {
      type: 'success',
      style: {
        backgroundColor: 'rgb(144 241 164 / 18%)',
        color: '#000',
        border: '1px solid rgb(82 244 152)',
      },
      className: 'alert-finalizado',
    },
    TRAMITE_INGRESO: { type: 'warning' },
  };

  const config = customConfig[upperStatus] || { type: 'info' };

  return (
    <Alert
      message={status || 'Desconocido'}
      type={config.type}
      showIcon
      style={config.style}
      className={config.className}
    />
  );
};

export default CustomAlert;
